import { uploadString } from 'firebase/storage';
import { functions, storage } from 'firebaseSDK';
import { Timestamp } from 'firebase/firestore';
import { verificationStatusTypes } from '../../config/types';
import Actions from './abstract/Actions';

class GeneralActions extends Actions {
  async addBankAccount(data) {
    const result = await functions.plaid.createPaymentRecipient({
      ...data,
    });
    console.log(result);

    if (result?.data?.error_code) {
      throw new Error(result.data.error_code);
    }

    return result;
  }

  async sendVerificationRequest(data) {
    const currentDate = Timestamp.now();
    const { idImageData, ...verificationRequestData } = data;
    const idImageRef = storage.getCurrentAccountImage('id');

    await uploadString(idImageRef, idImageData, 'data_url');
    await functions.admin.createVerificationRequest();
    await this.root.userDataState.publicAccount.update({
      dateUpdated: currentDate,
      proprietor: {
        ...verificationRequestData,
      },
      verificationStatus: verificationStatusTypes.PENDING,
    });
  }
}

export default GeneralActions;
